<div class="row justify-content-center mb-4">
  <button
    class="btn btn--paybee btn--black"
    (click)="addNewQuestion()"
  >Add new Question/Answer</button>
</div>

<ng-container *ngIf="options && (options?.length > 0)">
  <ng-container [formGroup]="faqForm">
  <ul class="list-group ui-sortable" formArrayName="options" cdkDropList (cdkDropListDropped)="dropOption($event)">
    <li class="list-group-item" *ngFor="let option of options.controls;index as i;" cdkDragLockAxis="y" cdkDrag>
      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div class="preset-option d-flex">
        <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
          <app-icon-menu></app-icon-menu>
        </div>
        <div [formGroup]="option" class="preset-option__content d-flex align-items-center">
          <div class="preset-option__number">{{i+1}}.</div>
          <div class="preset-option__container d-flex flex-column">
            <div class="preset-option__name mb-2" [innerHTML]="option.value.question"></div>
            <div class="preset-option__description mb-1" [innerHTML]="option.value.answer"></div>
          </div>
          <div class="preset-option__actions">
            <div class="preset-option__action">
              <app-icon-pen (click)="editAdditionalGuestInfo(option.value, i)"></app-icon-pen>
            </div>
            <div class="preset-option__action" (click)="removeOption(i)">
              <app-icon-trash></app-icon-trash>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
  </ng-container>
</ng-container>

